import React from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { connect } from "react-redux";

import { setModal, addToast } from "../../../actions/index";

import NewPlaylist from '../form/NewPlaylist';
import ModalCTA from '../modal/ModalCTA';

// TODO - Clean / Optimisation - Create Hook with useSelector

function ConnectedMenuNewPlaylist({
  style,
  isConnected, enable, storePopup, storePlaylists, selectedItems, 
  setModal, addToast,
  defaultClassColor = `type-secondary`, children
}) {

  const createPlaylist = (items) => (source) => {
    const name = source.name;
    const extra = (source.extra) ? source.extra : {};

    if (enable) {
      if (items.length > 0) {
        const previews = items.filter( x => x.is_available_for_streaming === false );
        const selection = items.filter( x => x.is_available_for_streaming === true );
        storePlaylists.new(name, selection, extra);
        addToast({ content: <span>Playlist '{name}' created.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } });
        if (selection.length > 0) {
          addToast({ content: <span>{items.length} track(s) added to '{name}'.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } });
        }
        if (previews.length > 0) {
          addToast({ content: <span>{previews.length} track(s) not added to '{name}'. Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } });
        }
        if (isConnected) { // Reporting
          const dataEvent = selectedItems.map( x => {
            const source_item_type = (x.from && x.from.includes(`charts`)) ? `Playlist`: `Release`;
            const source_item_id = (x.from && x.from.includes(`charts`)) ? x.from.split(`/`).pop() : x.releaseID;
            return { track_id: x.id, source_item_type, source_item_id }
          } );
          storePlaylists.report(`/events/add-to-playlist/`, dataEvent);
        }
      }
    } else {
      storePopup.playlist();
    }

  }

  const [{ el, canDrop, isOver }, refDrop] = useDrop({
    accept: ['TRACK', 'PLAYLIST', 'CHART', 'CHART-NAV', 'TRACK-CARD', 'RELEASE', 'DECK'],
    drop: createPlaylist(selectedItems),
    collect: (monitor) => ({
      el: monitor.getItem(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })
  const hasSelectedItems = (selectedItems.length > 0);
  const isDrop = (hasSelectedItems && canDrop && isOver);
  const opacity = (el && el.type === `CHART` && !hasSelectedItems) ? 0.2 : 1;
  const newPlaylist = () => {
    if (enable) {
      const modalNewPlaylist = () => {
        setModal({ // V2
          content: (
            <ModalCTA
              title={`Create playlist`}
              styleContainer={{marginTop: `-50%`, marginLeft: `-5%`}}
              styleBody={{gap: 16}}
              styleGroupCta={{gap: 32}}
              classModal={`bottom-reduce`}
            >
              <NewPlaylist />
            </ModalCTA>
          )
        });
      }
      if (storePlaylists.playlists.length === 0) {
        storePopup.noPlaylistTransfert(modalNewPlaylist);
      } else {
        modalNewPlaylist();
      }
    } else {
      storePopup.playlist();
    }
  }

  return (
    <div id={`l-new-playlist`} ref={refDrop}
      className={`type-small menu-new-playlist flexRow ${isDrop && `drop-new-playlist`} ${isDrop ? `brand-primary` : defaultClassColor }`}
      onClick={newPlaylist} style={{ ...style, opacity, cursor: (isDrop) ? `copy` : `pointer`  }} >
        { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
    </div>
  )
}

ConnectedMenuNewPlaylist.propTypes = {
  style: PropTypes.object,
  enable: PropTypes.bool.isRequired,
}

const MenuNewPlaylist = connect(
  state => ({
    isConnected: state.isConnected,
    enable: (state.isConnected),
    storePopup: state.storePopup,
    selectedItems: state.selectedItems,
    storePlaylists: state.storePlaylists
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    addToast: content => dispatch(addToast(content))
  })
)(ConnectedMenuNewPlaylist);

export default MenuNewPlaylist;
